import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import {
  HeroType,
  ModelDetailType,
  ModelSeoDataType,
  SimilarCarType,
  VariantsListType,
  VehicleImageType,
} from '../types/index';
import { getHeaders } from '../utils/headers';

const serializeModelData = (res) => {
  const variants: VariantsListType[] = res?.variant_list?.map(
    (item: any, idx: number) => ({
      variantKey: item?.variant_id,
      variantName: item?.variant_display_name || 'NA',
      price: item?.ex_showroom_price_slug || item?.on_road_price_slug || null,
      priceInNumbers: item?.ex_showroom_price || null,
      engine: item?.engine || null,
      transmission: item?.transmission ?? '',
      fuelType: item?.fuel || null,
      mileageInNumbers: item?.mileage_arai || item?.mileage || null,
      mileage: item?.mileage_arai_slug || null,
      seatingCapacity: item?.seating_capacity || null,
      img: res?.model_details?.thumbnail || null,
      slug: item?.variant_display_slug || null,
      drivingRange: res?.specifications?.driving_range || null,
    })
  );

  const priceResponse: any = res?.variant_locale_list?.map((item) => ({
    cityId: item?.locale_id || null,
    variantId: item?.variant_id || null,
    emi: item?.emi?.title || item?.emi?.emi || 'N/A',
    insurance: item?.insurance || 'N/A',
    exShowRoomPrice: item?.ex_showroom_price || 'N/A',
    rto: item?.rto || 'N/A',
    otherCharges: item?.other || null,
    onRoadPrice: item?.on_road_price_slug || item?.on_road_price || 'N/A',
    cityName: item?.locale_name || 'N/A',
  }));

  const hero: HeroType = {
    logo: res?.model_details?.brand_logo || null,
    brandName: res?.model_details?.brand_name || null,
    modelName: res?.model_details?.model_name || null,
    minPrice: +res?.model_details?.min_price || null,
    bodyType: res?.seo_data?.body || null,
    colors: !!res?.color_list?.length
      ? res?.color_list?.map((item) => ({
          image: item?.url,
          color: item?.name,
          colorCode: item?.base_hex_code,
        }))
      : null,
    image: res?.model_details?.thumbnail || null,
    fuelType: res?.model_details?.fuel || null,
    transmission: res?.model_details?.transmission || null,
    seatingCapacity: res?.model_details?.seating_capacity || null,
    ratingValue: res?.model_details?.rating || null,
    reviewCount: res?.model_details?.ratingCount || null,
    engineType: res?.model_details?.engine || null,
    engineDisplacement: res?.model_details?.min_engine_displacement || null,
    torque: res?.model_details?.max_torque || null,
    enginePower: res?.model_details?.max_power || null,
    mileage: res?.model_details?.min_mileage_slug || null,
    launchDate: res?.model_details?.launch_date || null,
  };
  // const specifications: CarSpecificationType = {
  //   engine: res?.key_spec_list?.engine || null,
  //   mileage: res?.specifications?.mileage || null,
  //   fuelType: res?.specifications?.fuel_type || null,
  //   seatingCapacity: res?.specifications?.seating_capacity || null,
  //   transmission: res?.specifications?.transmission || null,
  //   batteryCapacity: res?.specifications?.battery_capacity || null,
  //   drivingRange: res?.specifications?.driving_range || null,
  //   bodyType: res?.specifications?.body_type || null,
  // };
  const specifications = res?.key_spec_list;

  const modelSeoData: ModelSeoDataType = {
    baseVariant: res?.seo_data?.base_variant || '',
    baseVariantPrice: res?.seo_data?.base_variant_price || '',
    topVariant: res?.seo_data?.costliest_variant || '',
    topVariantPrice: res?.seo_data?.costliest_variant_price || '',
    noOfColors: res?.header?.colored_model_images?.length || '',
    brandSlug: res?.model_details?.brand_name_slug || '',
    modelSlug: res?.model_details?.model_name_slug || '',
    baseVariantMileage: res?.seo_data?.base_variant_mileage_slug || '',
    topVariantMileage: res?.seo_data?.costliest_variant_mileage_slug || '',
  };

  const vehicleImages: VehicleImageType = {
    exterior: res?.media_list?.exterior || null,
    interior: res?.media_list?.interior || null,
    frontImage: res?.model_details?.cover || null,
    logo: res?.model_details?.brand_logo || null,
  };
  const similarCars: SimilarCarType[] = res?.similar_model_list?.map(
    (car: any) => ({
      modelId: car?.model_id || null,
      image: car?.model_image || null,
      modelSlug: car?.model_slug || null,
      name: car?.model_name || '-',
      priceRange: car?.price_range || '-',
      brandSlug: car?.brand_slug || null,
    })
  );
  const result: ModelDetailType = {
    hero: hero,
    variants: variants || null,
    specifications: specifications,
    modelSeoData,
    vehicleImages,
    priceResponse,
    similarCars,
    modelId: res?.model_details?.model_id,
  };
  return result;
};
const fetchModelDetails = async (model: any, cityId?: number) => {
  const url = cityId
    ? `${apiConfig(
        'chariot'
      )}/v1/model/details?model_slug=${model}&source=seo&locale_id=${cityId}`
    : `${apiConfig('chariot')}/v1/model/details?model_slug=${model}&source=seo`;
  const { response, error }: any = await getMethod({
    endPoint: url,
    headers: getHeaders(),
  });
  if (response) {
    return serializeModelData(response?.data);
  } else return null;
};
export default fetchModelDetails;
